import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_wallet",
  "use": "svg_wallet-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"svg_wallet\"><path d=\"M4.45 6v12a1.5 1.5 0 0 0 1.5 1.5h15a.75.75 0 0 0 .75-.75V8.25a.75.75 0 0 0-.75-.75h-15A1.5 1.5 0 0 1 4.45 6Zm0 0a1.5 1.5 0 0 1 1.5-1.5H18.7\" stroke=\"#747478\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M17.575 14.438a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.874Z\" fill=\"#747478\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol